import React, { useState } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { closeShippingLabelsService } from "../../../services/pnlReport.service";
import { loadEntityList, monthLabel, PNL_STATUS, SHIPPING_LABELS } from "./pnlReportUtils";

export const canCloseReturns = (row) =>
  row.category === SHIPPING_LABELS && row.statusCode === PNL_STATUS.AWAITING_RETURNS;

const PnLCloseReturns = ({ row, onClosed }) => {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const label = monthLabel(row.year, row.month);
  const carrier = row.subType;

  const handleClose = async () => {
    setBusy(true);
    const { error } = await loadEntityList(() =>
      closeShippingLabelsService({ year: row.year, month: row.month, carrier })
    );
    if (error) {
      toast.error(error);
      setBusy(false);
      return;
    }
    toast.success(`${carrier} shipping-label returns for ${label} are closed.`);
    onClosed();
  };

  return (
    <section className="pnl-detail-section pnl-close-returns">
      <h3>Close returns</h3>
      <p className="pnl-detail-note">
        Close only after all {carrier} refund and adjustment files for {label} have been uploaded and processed.
      </p>
      {!confirming && (
        <button type="button" className="btn cus-seconday-bg-btn" onClick={() => setConfirming(true)}>
          Close {carrier} returns for {label}
        </button>
      )}
      {confirming && (
        <div className="pnl-confirm" role="alertdialog" aria-label={`Confirm closing ${carrier} returns for ${label}`}>
          <p>
            This locks <strong>{carrier}</strong> shipping labels for {label}. Refunds posted afterwards will not change
            this carrier&apos;s month. Other carriers stay open. This cannot be undone.
          </p>
          <div className="pnl-confirm-actions">
            <button type="button" className="btn cus-primary-transparent-btn" onClick={() => setConfirming(false)} disabled={busy}>
              Cancel
            </button>
            <button type="button" className="btn cus-seconday-bg-btn" onClick={handleClose} disabled={busy}>
              {busy ? "Closing..." : "Close returns"}
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

PnLCloseReturns.propTypes = {
  row: PropTypes.shape({
    year: PropTypes.number.isRequired,
    month: PropTypes.number.isRequired,
    subType: PropTypes.string.isRequired,
  }).isRequired,
  onClosed: PropTypes.func.isRequired,
};

export default PnLCloseReturns;
